export const EDUCATOR_PRACTICES_HEADER_TEXT = 'Educator Practices'
export const SCHOOL_HEADER_TEXT = 'School'
export const SCHOOLWIDE_PRACTICES_HEADER_TEXT = 'Schoolwide Practices'
export const STUDENT_ACTIVITIES_HEADER_TEXT = 'Student Activities'
export const TIER2_ACTIVE_GROUPS_LABEL = 'Active Groups'
export const TIER2_HIDDEN_GROUPS_LABEL = 'Hidden Groups'
